module.exports = __webpack_public_path__ + "static/1-ddd4a72370fc5940dc868f79c1a05886.png";